module.exports = __webpack_public_path__ + "64f3f38d0aa2d671380640eded119c0e.png";